import {Badge, Box, Button, Chip, Stack, Typography, useTheme} from '@mui/material';
import {IconIllustration, StyledCard} from 'presentation/components';
import React from 'react';
import {NotificationCardProps} from './types';
import {translations} from 'presentation/translations-new';

const {actionRequired} = translations['pt-br'].privateFlow.notifications;

export const NotificationCard = ({
	iconName,
	variantIcon,
	title,
	description,
	isActionRequired,
	unread = false,
	actions = [],
}: NotificationCardProps) => {
	const theme = useTheme();

	return (
		<Badge
			color="error"
			variant="dot"
			invisible={!unread}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			sx={{
				'& .MuiBadge-badge': {
					top: 12,
					right: 12,
				},
			}}>
			<StyledCard.Container
				sx={{
					width: '100%',
					display: 'block',
					backgroundColor: !unread ? 'rgba(255, 255, 255, 0.50)' : undefined,
				}}>
				<Stack
					sx={{
						flexDirection: 'row',
						alignItems: 'start',
						gap: 2,
					}}>
					<Box>
						<IconIllustration
							variant={variantIcon}
							customIconName={iconName}
							size="small"
						/>
					</Box>

					<Stack flex={1} spacing={0.5}>
						{isActionRequired ? (
							<Chip
								label={actionRequired}
								size="small"
								color="warning"
								sx={{
									width: 'fit-content',
									fontSize: '0.75rem',
									fontWeight: 600,
									color: theme.colors.brand.primary.white,
									backgroundColor: theme.colors.dark.secondary.highlight,
								}}
							/>
						) : null}

						<Typography fontWeight={600}>{title}</Typography>

						<Typography>{description}</Typography>
					</Stack>
				</Stack>
				<Stack direction="row" spacing={1} justifyContent="flex-end" mt={2}>
					{actions
						?.filter(action => action.shouldShow !== false)
						.map((action, index) => (
							<Button
								key={index}
								size="medium"
								variant={action.variant || 'contained'}
								onClick={action.onClick}>
								{action.label}
							</Button>
						))}
				</Stack>
			</StyledCard.Container>
		</Badge>
	);
};
